/*
 *
 *   reducer
 *
 */
import produce from "immer"
//import key from './key'

import {
  LOAD_RECORDS_META_DATA_SUCCESS,

  LOAD_RECORDS_META_DATA_ERROR,
  LOAD_DATA_COPY_SUCCESS,
  LOAD_DATA_COPY_ERROR,


  LOAD_DATA_LINK_DETAILS_SUCCESS,
} from "./constants"

const initialState = {
  recordsMetaData: {},
  data_copy_details: [],
  data_link_details: [],

  loading: false,
  error: false,
  success: false,

}

export default function Reducer(
  state = initialState,
  {
    type,
    recordsMetaData = {},
    data_copy_details = [],
    data_link_details= [],
    error,
    success,
  }
) {
  return produce(state, (draft) => {
    switch (type) {
      case LOAD_RECORDS_META_DATA_SUCCESS:
        draft.recordsMetaData = Object.assign(
          {},
          state.recordsMetaData,
          recordsMetaData
        )
        draft.error = false
        draft.success = success
        break
    
      case LOAD_DATA_COPY_SUCCESS:
        draft.data_copy_details = data_copy_details
        draft.lastUpdate = Math.floor(Date.now() / 1000)
        draft.loading = false
        draft.error = false
        draft.success = success
        break
     
      //Data Link

      case LOAD_DATA_LINK_DETAILS_SUCCESS:
        draft.data_link_details = data_link_details
        draft.lastUpdate = Math.floor(Date.now() / 1000)
        draft.loading = false
        draft.error = false
        draft.success = false
        break
    
      case LOAD_DATA_COPY_ERROR:
      case LOAD_RECORDS_META_DATA_ERROR:
        draft.loading = false
        draft.error = error
        draft.success = false
        break
    }
  })
}
